export class FormUtil {
  public static getFormData = (data: any, form?: FormData, previousKey?: string): FormData => {
    let formData = form ?? new FormData();

    if (data instanceof Object) {
      Object.keys(data).forEach(key => {
        const value = data[key];
        if (value instanceof Object && !Array.isArray(value)) {
          return this.getFormData(formData, value, key);
        }
        if (previousKey) {
          key = `${previousKey}[${key}]`;
        }
        if (Array.isArray(value)) {
          value.forEach(val => {
            formData.append(`${key}[]`, val);
          });
        } else {
          formData.append(key, value);
        }
      });
    }

    return formData
  }
  
}